/* esm.sh - rxjs@7.8.2/dist/esm/internal/operators/count */
import{reduce as c}from"rxjs/dist/esm/internal/operators/reduce";function f(r){return c((n,o,u)=>!r||r(o,u)?n+1:n,0)}export{f as count};
//# sourceMappingURL=count.mjs.map